import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseGetAll } from '../../shared/commons/generic.responses';
import { endpoints } from '../../shared/apis/endpoints';
import { PermissionService } from '../../admin/services/permission.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public sessionExpired: EventEmitter<any> = new EventEmitter();

  constructor(
    private _http: HttpClient,
    private _permissionService: PermissionService
  ) { }

  Login(email: string, password: string): Observable<BaseGetAll<string>> {
    return this._http.post<BaseGetAll<string>>(endpoints.LOGIN, { email, password });
  }

  Logout(): void {
    // Limpiar token
    localStorage.removeItem('tristateToken');
    
    // Limpiar permisos almacenados
    this._permissionService.clearStoredPermissions();
    
    console.log('User logged out, permissions cleared');
  }

  EmitSessionExpiredEvent() {
    this.sessionExpired.emit();
    this.Logout(); // Limpiar sesión cuando expire
  }

}
